var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackdropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0575 8.85891C4.00917 8.81182 3.8025 8.63403 3.6325 8.46842C2.56333 7.49748 0.813333 4.9646 0.279167 3.6389C0.193333 3.43757 0.0116667 2.92856 0 2.6566C0 2.39601 0.06 2.14759 0.181667 1.91054C0.351667 1.61503 0.619167 1.37798 0.935 1.24809C1.15417 1.16447 1.81 1.03458 1.82167 1.03458C2.53917 0.904692 3.705 0.833252 4.99333 0.833252C6.22083 0.833252 7.33917 0.904692 8.0675 1.01104C8.07917 1.02322 8.89417 1.15311 9.17333 1.29518C9.68333 1.55577 10 2.06478 10 2.60951V2.6566C9.9875 3.01137 9.67083 3.75743 9.65917 3.75743C9.12417 5.01169 7.46 7.48612 6.35417 8.4806C6.35417 8.4806 6.07 8.76068 5.8925 8.88245C5.6375 9.07241 5.32167 9.16659 5.00583 9.16659C4.65333 9.16659 4.325 9.06024 4.0575 8.85891Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackdropdown);
export default __webpack_public_path__ + "static/media/blackdropdown.f9378de5103a61f1944a9cdaa5ae37dd.svg";
export { ForwardRef as ReactComponent };